/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityThreatValidationForOCIResponse {
    getFixupPrototypeFunction() { return SecurityThreatValidationForOCIResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityThreatValidationForOCIResponse>): SecurityThreatValidationForOCIResponse {
        let obj = Object.assign(new SecurityThreatValidationForOCIResponse(), model);
        SecurityThreatValidationForOCIResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityThreatValidationForOCIResponse>): SecurityThreatValidationForOCIResponse {
        if (!model) return null;
        return SecurityThreatValidationForOCIResponse.newInstance(<SecurityThreatValidationForOCIResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityThreatValidationForOCIResponse) {
        if (!obj) return;

        models.SecurityThreatValidationForOCIResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityThreatValidationForOCIResponse): boolean {
        Object.setPrototypeOf(obj, SecurityThreatValidationForOCIResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * If set, Cloud Guard is enabled.
     */
    cloud_guard: boolean;

}
